import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@mui/material";
import styles from "./styles.module.css";
import { useState } from "react";
import { PagamentoEfetuado } from "../../../model/PrestacaoDeContas/RelacaoPagamentosEfetuados";
import { toIsoString } from "../../../controllers/Converters";
import Modal from "react-responsive-modal";
import ModalRelacaoPagamentos from "../../../components/ModalForms/ModalRelacaoPagamentos";

const PagamentosEfetuados = () => {
  const [showAddPagamento, setAddPagamento] = useState(false);
  const [showEditPagamento, setEditPagamento] = useState(-1);
  const [pagamentos, setPagamentos] = useState<PagamentoEfetuado[]>([
    {
      recurso: 1,
      nomeFavorecido: "Paulo Cesar Alvez Tamanaha",
      cnpjCpf: "34.872.884/0001-96",
      licitacao: "NA",
      documento: {
        tipo: "NF",
        numero: "47",
        data: new Date(Date.now()),
      },
      pagamento: {
        CHOB: "ESPECIE",
        data: new Date(Date.now()),
      },
      naturezaDespesa: "3.3.50.43.99",
      valor: 960,
    },
    {
      recurso: 1,
      nomeFavorecido: "Paulo Cesar Alvez Tamanaha",
      cnpjCpf: "34.872.884/0001-96",
      licitacao: "NA",
      documento: {
        tipo: "NF",
        numero: "47",
        data: new Date(Date.now()),
      },
      pagamento: {
        CHOB: "ESPECIE",
        data: new Date(Date.now()),
      },
      naturezaDespesa: "3.3.50.43.99",
      valor: 960,
    },
    {
      recurso: 1,
      nomeFavorecido: "Paulo Cesar Alvez Tamanaha",
      cnpjCpf: "34.872.884/0001-96",
      licitacao: "NA",
      documento: {
        tipo: "NF",
        numero: "47",
        data: new Date(Date.now()),
      },
      pagamento: {
        CHOB: "ESPECIE",
        data: new Date(Date.now()),
      },
      naturezaDespesa: "3.3.50.43.99",
      valor: 960,
    },
    {
      recurso: 1,
      nomeFavorecido: "Paulo Cesar Alvez Tamanaha",
      cnpjCpf: "34.872.884/0001-96",
      licitacao: "NA",
      documento: {
        tipo: "NF",
        numero: "47",
        data: new Date(Date.now()),
      },
      pagamento: {
        CHOB: "ESPECIE",
        data: new Date(Date.now()),
      },
      naturezaDespesa: "3.3.50.43.99",
      valor: 960,
    },
  ]);

  return (
    <form className={styles.formCadastro} onSubmit={(e) => e.preventDefault()}>
      <div>
        <h2 className={styles.titulo}>
          4. Relação de <strong>Pagamentos Efetuados</strong>
        </h2>
        <div className={styles.table}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center" rowSpan={2}>
                    RECURSO
                  </TableCell>
                  <TableCell align="center" rowSpan={2}>
                    N°
                  </TableCell>
                  <TableCell align="center" rowSpan={2}>
                    FAVORECIDO
                  </TableCell>
                  <TableCell align="center" rowSpan={2}>
                    CNPJ/CPF
                  </TableCell>
                  <TableCell align="center" rowSpan={2}>
                    LICITAÇÃO
                  </TableCell>
                  <TableCell align="center" colSpan={3}>
                    DOCUMENTO
                  </TableCell>
                  <TableCell align="center" colSpan={2}>
                    PAGAMENTO
                  </TableCell>
                  <TableCell align="center" rowSpan={2}>
                    NATURESA DE DESPESA
                  </TableCell>
                  <TableCell align="center" rowSpan={2}>
                    VALOR
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="center">TIPO</TableCell>
                  <TableCell align="center">N°</TableCell>
                  <TableCell align="center">DATA</TableCell>
                  <TableCell align="center">CH/OB</TableCell>
                  <TableCell align="center">DATA</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pagamentos.map((pagamento, index) => (
                  <>
                    <TableRow
                      hover
                      role="checkbox"
                      sx={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault();
                        setEditPagamento(index);
                      }}
                    >
                      <TableCell align="center">{pagamento.recurso}</TableCell>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell>{pagamento.nomeFavorecido}</TableCell>
                      <TableCell align="center">{pagamento.cnpjCpf}</TableCell>
                      <TableCell align="center">
                        {pagamento.licitacao}
                      </TableCell>
                      <TableCell align="center">
                        {pagamento.documento.tipo}
                      </TableCell>
                      <TableCell align="center">
                        {pagamento.documento.numero}
                      </TableCell>
                      <TableCell align="center">
                        {toIsoString(pagamento.documento.data)}
                      </TableCell>
                      <TableCell align="center">
                        {pagamento.pagamento.CHOB}
                      </TableCell>
                      <TableCell align="center">
                        {toIsoString(pagamento.pagamento.data)}
                      </TableCell>
                      <TableCell align="center">
                        {pagamento.naturezaDespesa}
                      </TableCell>
                      <TableCell align="center">
                        R$
                        {Number(pagamento.valor).toFixed(2)}
                      </TableCell>
                    </TableRow>

                    <Modal
                      open={showEditPagamento === index}
                      onClose={() => {
                        setEditPagamento(-1);
                      }}
                      center
                      classNames={{
                        modal: "customModal",
                      }}
                    >
                      <ModalRelacaoPagamentos
                        closeModal={() => setEditPagamento(-1)}
                        setList={setPagamentos}
                        list={pagamentos}
                        index={index}
                        refPagamento={pagamento}
                      />
                    </Modal>
                  </>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={11}>TOTAL</TableCell>
                  <TableCell>
                    R$
                    {Number(
                      pagamentos.reduce(
                        (acc, current) => acc + Number(current.valor),
                        0
                      )
                    ).toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>

          <div className={styles.addDiv}>
            <button
              className={styles.addBtn}
              onClick={(e) => {
                e.preventDefault();
                setAddPagamento(true);
              }}
            >
              + Adicionar Meta
            </button>
          </div>
          <Modal
            open={showAddPagamento}
            onClose={() => setAddPagamento(false)}
            center
            classNames={{
              modal: "customModal",
            }}
          >
            <ModalRelacaoPagamentos
              closeModal={() => setAddPagamento(false)}
              setList={setPagamentos}
              list={pagamentos}
            />
          </Modal>
        </div>
      </div>
    </form>
  );
};
export default PagamentosEfetuados;
